import VadImage from "vadimages-nextjs-image-optimizer";
import React from "react";
import SingularGetSamplesBannerClient from "./SingularGetSamplesBannerClient";

const SingularGetSamplesBanner = () => {
  return (
    <div className="relative w-full px-6 py-10 md:px-16 lg:px-32 md:py-12">
      <div className="md:max-w-[1240px] md:mx-auto flex flex-col max-md:gap-5 md:flex-row justify-between items-center">
        <div className="text-white z-10">
          <h3 className="text-3xl lg:text-[40px] max-md:text-center mb-3">
            Join the new industry standard
          </h3>
          <SingularGetSamplesBannerClient />
        </div>
        <div className="flex items-center gap-7 z-10">
          <VadImage
            src="/images/singular/banner/banner-verano-family.png"
            alt="Banner Verano Family"
            width={256}
            height={193}
            className="rounded-default"
          />
          <VadImage
            src="/images/singular/banner/banner-trulieve-family.4.webp"
            alt="Banner Trulieve Family"
            width={256}
            height={193}
            className="rounded-default"
          />
        </div>
      </div>

      <div className="absolute w-full h-full left-0 top-0 overflow-hidden z-0">
        <VadImage
          src={`/images/singular/gradient.png`}
          alt="Background"
          width={1600}
          height={1600}
          className="pointer-events-none absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default SingularGetSamplesBanner;
